import { Stack } from "@mui/material"
import React, { useEffect, useState } from "react"
import UseGetStepHookDucPage from "../UseGetStepHookDucPage"
import PiModal from "./PiModal";
import AIANBlockSteper from "./AIANBlockStepper";
import DUCDeleteModal from "./DUCDeleteModal";
import AIANBlockButtons from "./AIANBlockButtons";
import { useUserInfoQuery } from "../../../api/userApiSlice";
import { useGetDUCInfoQuery } from "../../../api/ducApiSlice";
import { getRenewalStatus } from "../utils/renewalWindow";



const AIANBlockComponent = () => {

    //We need expiry and expired because we need a different 
    //status chip for each one
    const [activeStepAIAN, setActiveStepAIAN] = useState(0);
    const [expiringAIAN, setExpiringAIAN] = useState(false);
    const [expiredAIAN, setExpiredAIAN] = useState(false);
    const [declinedAIAN, setDeclinedAIAN] = useState(false);
    const [checkedCurrentStatus, setCheckedCurrentStatus] = useState(false)
    const [open, setOpen] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [cancelRefresh, setCancelRefresh] = useState(false)
    const { data: userData } = useUserInfoQuery({});
    const { data: ducDataObject } = useGetDUCInfoQuery({ email: userData?.email });
    const ducData = ducDataObject?.AIAN?.[ducDataObject?.AIAN.length - 1]

    // The PI's AIAN application must be individual/group exactly matching their currently
    // Approved General DUC - find that record (not just the last General entry, which could be
    // a not-yet-approved renewal) so we know which option to lock the PI into below.
    const approvedGeneral = (ducDataObject?.GENERAL as any[] | undefined)
        ?.slice().reverse().find(gen => gen?.status === 'Approved')
    const requiredIsGroupForAian: boolean | undefined = approvedGeneral?.group

    UseGetStepHookDucPage(ducData, setActiveStepAIAN, setExpiredAIAN, setExpiringAIAN, setDeclinedAIAN, setCheckedCurrentStatus)

    // Ensure expiring/expired reflect the most recent Approved AIAN DUC when multiple entries exist
    useEffect(() => {
        const aianList = ducDataObject?.AIAN as any[] | undefined;
        if (!aianList || aianList.length === 0) return;

        let latestApproved: any | null = null;
        for (let i = aianList.length - 1; i >= 0; i--) {
            if (aianList[i]?.status === 'Approved') {
                latestApproved = aianList[i];
                break;
            }
        }

        if (latestApproved) {
            const { expired: isExpired, expiring: isExpiring } = getRenewalStatus({
                status: latestApproved?.status,
                expiresOn: latestApproved?.expiresOn,
            });
            setExpiredAIAN(isExpired);
            setExpiringAIAN(isExpiring);
        }
    }, [ducDataObject]);


    return (
        <Stack
            component="section"
            aria-labelledby="aian-header"
            flexDirection="column"
            justifyContent="space-between"
            gap={3}
            padding="20px"
            marginBottom="30px"
            sx={{
                backgroundColor: "white"
            }}
        >
            <PiModal open={open} setOpen={setOpen} type="AIAN" requiredIsGroup={requiredIsGroupForAian}/>
            <DUCDeleteModal open={openDeleteModal} setOpen={setOpenDeleteModal} type="AIAN" />
            <AIANBlockButtons
                expired={expiredAIAN}
                expiring={expiringAIAN}
                setOpen={setOpen}
                setCancelRefresh={setCancelRefresh}
                cancelRefresh={cancelRefresh}
                setOpenDeleteModal={setOpenDeleteModal}
                checkedCurrentStatus={checkedCurrentStatus}
            />

            <Stack>
                {/* Once the user's overall status is DucExpired, only show a single stepper
                    (the current/most recent AIAN record) instead of one per record - mirrors
                    the same fix in GeneralBlockComponent for the duplicate-looking timeline. */}
                {ducDataObject?.ducStatus === 'DucExpired'
                    ? (
                        <AIANBlockSteper
                            ducData={ducData}
                            declinedAIAN={declinedAIAN}
                            expiredAIAN={expiredAIAN}
                            key={0}
                            index={0}
                            activeStepAIAN={activeStepAIAN}
                        />
                    )
                    : ducDataObject?.AIAN.map((aianDucData: any, index: number) => {
                        return (
                            <AIANBlockSteper
                                ducData={aianDucData}
                                declinedAIAN={declinedAIAN}
                                expiredAIAN={expiredAIAN}
                                key={index}
                                index={index}
                                activeStepAIAN={activeStepAIAN}
                            />
                        )
                    })}
            </Stack>
        </Stack>
    )


}

export default AIANBlockComponent